import { render, staticRenderFns } from "./goddess_contest.vue?vue&type=template&id=3c4e67cf&scoped=true"
import script from "./goddess_contest.vue?vue&type=script&lang=ts"
export * from "./goddess_contest.vue?vue&type=script&lang=ts"
import style0 from "./goddess_contest.vue?vue&type=style&index=0&id=3c4e67cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e67cf",
  null
  
)

export default component.exports